import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { contentTypes, contentActions } = createActionsStructure('content', [
  { name: 'GET_MAJORS_CONTENT', async: true },
  { name: 'GET_HOUSING_CONTENT', async: true },
  { name: 'GET_VERIFY_INFO_CONTENT', async: true }
])
